import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b61305d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-viewer-deny-item item-viewer-deny-padding" }
const _hoisted_2 = { class: "not-published has-background-contents shadow" }
const _hoisted_3 = {
  key: 0,
  class: "not-published-section",
  "data-cy": "not-published-section-persend-isnt-logged-in"
}
const _hoisted_4 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_5 = { class: "has-text-table-item-content" }
const _hoisted_6 = { class: "not-published-section-heading title" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "not-published-section-body" }
const _hoisted_9 = { class: "is-mobile" }
const _hoisted_10 = {
  key: 1,
  class: "not-published-section",
  "data-cy": "not-published-section-persend-isnt-user"
}
const _hoisted_11 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_12 = { class: "has-text-table-item-content" }
const _hoisted_13 = { class: "not-published-section-heading title" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "not-published-section-body" }
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 2,
  class: "not-published-section",
  "data-cy": "not-published-section-persend-is-officials-and-isnt-consented"
}
const _hoisted_18 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_19 = { class: "has-text-table-item-content" }
const _hoisted_20 = { class: "not-published-section-heading title" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "not-published-section-body" }
const _hoisted_23 = {
  key: 3,
  class: "not-published-section",
  "data-cy": "not-published-section-persend-outside-of-japan"
}
const _hoisted_24 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_25 = { class: "has-text-table-item-content" }
const _hoisted_26 = { class: "not-published-section-heading title" }
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "not-published-section-body" }
const _hoisted_29 = { class: "is-mobile" }
const _hoisted_30 = {
  key: 4,
  class: "not-published-section",
  "data-cy": "not-published-section-persend-in-restriction"
}
const _hoisted_31 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_32 = { class: "has-text-table-item-content" }
const _hoisted_33 = { class: "not-published-section-heading title" }
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "not-published-section-body" }
const _hoisted_36 = ["href"]
const _hoisted_37 = ["href"]
const _hoisted_38 = {
  key: 5,
  class: "not-published-section",
  "data-cy": "not-published-section-persend-isnt-officials-and-isnt-consented"
}
const _hoisted_39 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_40 = { class: "has-text-table-item-content" }
const _hoisted_41 = { class: "not-published-section-heading title" }
const _hoisted_42 = ["href"]
const _hoisted_43 = { class: "not-published-section-body" }
const _hoisted_44 = {
  key: 6,
  class: "not-published-section",
  "data-cy": "not-published-section-persend-in-application"
}
const _hoisted_45 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_46 = { class: "has-text-table-item-content" }
const _hoisted_47 = { class: "not-published-section-heading title" }
const _hoisted_48 = ["href"]
const _hoisted_49 = { class: "not-published-section-body" }
const _hoisted_50 = {
  key: 7,
  class: "not-published-section",
  "data-cy": "not-published-section-persend-isnt-resistered"
}
const _hoisted_51 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_52 = { class: "has-text-table-item-content" }
const _hoisted_53 = { class: "not-published-section-heading title" }
const _hoisted_54 = ["href"]
const _hoisted_55 = { class: "not-published-section-body" }
const _hoisted_56 = {
  key: 8,
  class: "not-published-section",
  "data-cy": "not-published-section-libsend"
}
const _hoisted_57 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_58 = { class: "has-text-table-item-content" }
const _hoisted_59 = { class: "not-published-section-heading title" }
const _hoisted_60 = ["href"]
const _hoisted_61 = { class: "not-published-section-body" }
const _hoisted_62 = {
  key: 9,
  class: "not-published-section",
  "data-cy": "not-published-section-use-ndl-online"
}
const _hoisted_63 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_64 = { class: "has-text-table-item-content" }
const _hoisted_65 = { class: "not-published-section-heading title" }
const _hoisted_66 = { class: "not-published-section-body" }
const _hoisted_67 = ["href"]
const _hoisted_68 = ["href"]
const _hoisted_69 = {
  key: 10,
  class: "not-published-section",
  "data-cy": "not-published-section-use-ndl"
}
const _hoisted_70 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_71 = { class: "has-text-table-item-content" }
const _hoisted_72 = { class: "not-published-section-heading title" }
const _hoisted_73 = { class: "not-published-section-body" }
const _hoisted_74 = { class: "level-left" }
const _hoisted_75 = ["href"]
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_77 = ["href"]
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_79 = ["href"]
const _hoisted_80 = {
  key: 11,
  class: "not-published-section",
  "data-cy": "not-published-section-use-rekion"
}
const _hoisted_81 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_82 = { class: "has-text-table-item-content" }
const _hoisted_83 = { class: "not-published-section-heading title" }
const _hoisted_84 = { class: "not-published-section-body" }
const _hoisted_85 = {
  key: 12,
  class: "not-published-section",
  "data-cy": "not-published-section-cannot-view"
}
const _hoisted_86 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_87 = { class: "has-text-table-item-content" }
const _hoisted_88 = { class: "not-published-section-heading title" }
const _hoisted_89 = { class: "not-published-section-body restriction-message" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = {
  key: 13,
  class: "not-published-section",
  "data-cy": "not-published-section-cannot-view"
}
const _hoisted_93 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_94 = { class: "has-text-table-item-content" }
const _hoisted_95 = { class: "not-published-section-heading title" }
const _hoisted_96 = { class: "not-published-section-body restriction-message" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = {
  key: 14,
  class: "not-published-section",
  "data-cy": "not-published-section-inlibrary-package-item"
}
const _hoisted_99 = { class: "not-published-section-label level-left is-mobile" }
const _hoisted_100 = { class: "not-published-section-heading title" }
const _hoisted_101 = {
  key: 0,
  class: "not-published-section-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIconPlaces = _resolveComponent("AppIconPlaces")!
  const _component_AppLabelPlaces = _resolveComponent("AppLabelPlaces")!
  const _component_TextLinkWithArrow = _resolveComponent("TextLinkWithArrow")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconNdlOnline = _resolveComponent("IconNdlOnline")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_DssIcon = _resolveComponent("DssIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.contentPermissionType === 'ooc' && !_ctx.isLoggedIn)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppIconPlaces, {
                    type: _ctx.contentPermissionType,
                    color: 'color-green'
                  }, null, 8, ["type"])
                ]),
                _: 1
              }, 8, ["type"]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.underIconMessage', { newLine: '\r\n' })), 1)
            ]),
            _createElementVNode("h1", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text1')) + " ", 1),
              _createElementVNode("a", {
                href: _ctx.$t('link.transmissionServiceForIndividuals'),
                rel: "noopener",
                class: "level-left is-mobile",
                style: {"display":"inline"}
              }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text2')), 9, _hoisted_7),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text3')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isntLoggedIn1', { newLine: '\r\n' })), 1),
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", null, [
                  _createVNode(_component_TextLinkWithArrow, {
                    href: _ctx.$t('link.register')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isntLoggedIn2')), 1)
                    ]),
                    _: 1
                  }, 8, ["href"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_TextLinkWithArrow, {
                    href: "javascript:void(0);",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.commit('SET_SHOW_LOGIN_MODAL', true))),
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.$store.commit('SET_SHOW_LOGIN_MODAL', true)), ["prevent"]), ["space","enter"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isntLoggedIn3')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]))
        : (_ctx.contentPermissionType === 'ooc' && _ctx.isLoggedIn && !_ctx.isPersendUserType)
          ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AppIconPlaces, {
                      type: _ctx.contentPermissionType,
                      color: 'color-green'
                    }, null, 8, ["type"])
                  ]),
                  _: 1
                }, 8, ["type"]),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.underIconMessage', { newLine: '\r\n' })), 1)
              ]),
              _createElementVNode("h1", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text1')) + " ", 1),
                _createElementVNode("a", {
                  href: _ctx.$t('link.transmissionServiceForIndividuals'),
                  rel: "noopener",
                  class: "level-left is-mobile",
                  style: {"display":"inline"}
                }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text2')), 9, _hoisted_14),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text3')), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isntUser1', { newLine: '\r\n' })) + " ", 1),
                  _createElementVNode("a", {
                    href: _ctx.$t('link.register'),
                    rel: "noopener",
                    class: "level-left is-mobile underline-default",
                    style: {"display":"inline"}
                  }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isntUser2', { newLine: '\r\n' })), 9, _hoisted_16),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isntUser3', { newLine: '\r\n' })), 1)
                ])
              ])
            ]))
          : (_ctx.contentPermissionType === 'ooc' && _ctx.isLoggedIn && _ctx.isOrganizationUserType && !_ctx.isSimple && !_ctx.isPersendAgreed)
            ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AppIconPlaces, {
                        type: _ctx.contentPermissionType,
                        color: 'color-green'
                      }, null, 8, ["type"])
                    ]),
                    _: 1
                  }, 8, ["type"]),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.underIconMessage', { newLine: '\r\n' })), 1)
                ]),
                _createElementVNode("h1", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text1')) + " ", 1),
                  _createElementVNode("a", {
                    href: _ctx.$t('link.transmissionServiceForIndividuals'),
                    rel: "noopener",
                    class: "level-left is-mobile",
                    style: {"display":"inline"}
                  }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text2')), 9, _hoisted_21),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text3')), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isOfficialsAndIsntConsented1', { newLine: '\r\n' })), 1),
                  _createVNode(_component_TextLinkWithArrow, {
                    href: _ctx.$t('link.termsAndConditions'),
                    target: "_blank",
                    class: "is-mobile"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isOfficialsAndIsntConsented2')), 1)
                    ]),
                    _: 1
                  }, 8, ["href"])
                ])
              ]))
            : (_ctx.contentPermissionType === 'ooc' && _ctx.isLoggedIn && _ctx.isRegistered && !_ctx.isLiveInJapan)
              ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AppIconPlaces, {
                          type: _ctx.contentPermissionType,
                          color: 'color-green'
                        }, null, 8, ["type"])
                      ]),
                      _: 1
                    }, 8, ["type"]),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.underIconMessage', { newLine: '\r\n' })), 1)
                  ]),
                  _createElementVNode("h1", _hoisted_26, [
                    _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text1')) + " ", 1),
                    _createElementVNode("a", {
                      href: _ctx.$t('link.transmissionServiceForIndividuals'),
                      rel: "noopener",
                      class: "level-left is-mobile",
                      style: {"display":"inline"}
                    }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text2')), 9, _hoisted_27),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text3')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.outsideOfJapan1', { newLine: '\r\n' })), 1),
                    _createElementVNode("ul", _hoisted_29, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_TextLinkWithArrow, {
                          href: _ctx.$t('link.transmissionServiceUsers')
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.outsideOfJapan2')), 1)
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_TextLinkWithArrow, {
                          href: _ctx.$t('link.confirmAndUpdateRegisteredAddress')
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.outsideOfJapan3')), 1)
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ])
                    ])
                  ])
                ]))
              : (_ctx.contentPermissionType === 'ooc' && _ctx.isLoggedIn && _ctx.isRegistered && _ctx.isPersendForbidden)
                ? (_openBlock(), _createElementBlock("section", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AppIconPlaces, {
                            type: _ctx.contentPermissionType,
                            color: 'color-green'
                          }, null, 8, ["type"])
                        ]),
                        _: 1
                      }, 8, ["type"]),
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.underIconMessage', { newLine: '\r\n' })), 1)
                    ]),
                    _createElementVNode("h1", _hoisted_33, [
                      _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text1')) + " ", 1),
                      _createElementVNode("a", {
                        href: _ctx.$t('link.transmissionServiceForIndividuals'),
                        rel: "noopener",
                        class: "level-left is-mobile",
                        style: {"display":"inline"}
                      }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text2')), 9, _hoisted_34),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text3')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.inRestriction1', { newLine: '\r\n' })) + " ", 1),
                        _createElementVNode("a", {
                          href: _ctx.$t('link.contactFormToNdl'),
                          rel: "noopener",
                          class: "level-left is-mobile underline-default",
                          style: {"display":"inline"}
                        }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.inRestriction2', { newLine: '\r\n' })), 9, _hoisted_36),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.inRestriction3', { newLine: '\r\n' })) + " ", 1),
                        (_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.inRestriction4'))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _ctx.$t('link.contactPhoneToNdl'),
                              rel: "noopener",
                              class: "level-left is-mobile underline-default",
                              style: {"display":"inline"}
                            }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.inRestriction4', { newLine: '\r\n' })), 9, _hoisted_37))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.inRestriction5', { newLine: '\r\n' })), 1)
                      ])
                    ])
                  ]))
                : (_ctx.contentPermissionType === 'ooc' && _ctx.isLoggedIn && _ctx.isRegistered && !_ctx.isSimple && !_ctx.isPersendAgreed)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AppIconPlaces, {
                              type: _ctx.contentPermissionType,
                              color: 'color-green'
                            }, null, 8, ["type"])
                          ]),
                          _: 1
                        }, 8, ["type"]),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.underIconMessage', { newLine: '\r\n' })), 1)
                      ]),
                      _createElementVNode("h1", _hoisted_41, [
                        _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text1')) + " ", 1),
                        _createElementVNode("a", {
                          href: _ctx.$t('link.transmissionServiceForIndividuals'),
                          rel: "noopener",
                          class: "level-left is-mobile",
                          style: {"display":"inline"}
                        }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text2')), 9, _hoisted_42),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text3')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isntOfficialsAndIsntConsented1', { newLine: '\r\n' })), 1),
                        _createVNode(_component_TextLinkWithArrow, {
                          href: _ctx.$t('link.termsAndConditions'),
                          target: "_blank",
                          class: "is-mobile"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isntOfficialsAndIsntConsented2')), 1)
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ])
                    ]))
                  : (_ctx.contentPermissionType === 'ooc' && _ctx.isLoggedIn && _ctx.isRegistered && _ctx.isApplying)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                            default: _withCtx(() => [
                              _createVNode(_component_AppIconPlaces, {
                                type: _ctx.contentPermissionType,
                                color: 'color-green'
                              }, null, 8, ["type"])
                            ]),
                            _: 1
                          }, 8, ["type"]),
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.underIconMessage', { newLine: '\r\n' })), 1)
                        ]),
                        _createElementVNode("h1", _hoisted_47, [
                          _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text1')) + " ", 1),
                          _createElementVNode("a", {
                            href: _ctx.$t('link.transmissionServiceForIndividuals'),
                            rel: "noopener",
                            class: "level-left is-mobile",
                            style: {"display":"inline"}
                          }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text2')), 9, _hoisted_48),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text3')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.inApplication', { newLine: '\r\n' })), 1)
                        ])
                      ]))
                    : (_ctx.contentPermissionType === 'ooc' && _ctx.isLoggedIn && _ctx.isRegistered && _ctx.isSimple)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AppIconPlaces, {
                                  type: _ctx.contentPermissionType,
                                  color: 'color-green'
                                }, null, 8, ["type"])
                              ]),
                              _: 1
                            }, 8, ["type"]),
                            _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.underIconMessage', { newLine: '\r\n' })), 1)
                          ]),
                          _createElementVNode("h1", _hoisted_53, [
                            _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text1')) + " ", 1),
                            _createElementVNode("a", {
                              href: _ctx.$t('link.transmissionServiceForIndividuals'),
                              rel: "noopener",
                              class: "level-left is-mobile",
                              style: {"display":"inline"}
                            }, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text2')), 9, _hoisted_54),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardTitle.text3')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isntResistered1', { newLine: '\r\n' })), 1),
                            _createVNode(_component_TextLinkWithArrow, {
                              href: _ctx.$t('link.registerOfficialUser'),
                              class: "is-mobile"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.usePersonalTransmission.cardMessage.isntResistered2')), 1)
                              ]),
                              _: 1
                            }, 8, ["href"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
      (_ctx.contentPermissionType === 'ooc')
        ? (_openBlock(), _createElementBlock("section", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppIconPlaces, {
                    type: _ctx.contentPermissionType,
                    color: 'color-green'
                  }, null, 8, ["type"])
                ]),
                _: 1
              }, 8, ["type"]),
              _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t('restrictionMessage.useLibraryTransmission.underIconMessage', { newLine: '\r\n' })), 1)
            ]),
            _createElementVNode("h1", _hoisted_59, [
              _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.useLibraryTransmission.cardTitle.text1')) + " ", 1),
              _createElementVNode("a", {
                href: _ctx.$t('link.transmissionServiceForLibraries'),
                rel: "noopener",
                class: "level-left is-mobile",
                style: {"display":"inline"}
              }, _toDisplayString(_ctx.$t('restrictionMessage.useLibraryTransmission.cardTitle.text2')), 9, _hoisted_60),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('restrictionMessage.useLibraryTransmission.cardTitle.text3')), 1)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('restrictionMessage.useLibraryTransmission.cardMessage')), 1),
              _createElementVNode("p", null, [
                _createVNode(_component_router_link, {
                  to: "/soshin_librarylist",
                  class: "level-left is-mobile underline-default"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('parts.listOfTransmissionLibrary')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.contentPermissionRule === 'ndl_only' || _ctx.contentPermissionRule === 'ndl_only_no_snippet' || (_ctx.contentPermissionRule === 'ndl_only_no_simview' && _ctx.isLoggedIn && _ctx.isRegistered) || _ctx.contentPermissionType === 'ooc')
        ? (_openBlock(), _createElementBlock("section", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_IconNdlOnline, { size: 'is-permission-panel' }),
              _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t('restrictionMessage.useNdlOnline.underIconMessage', { newLine: '\r\n' })), 1)
            ]),
            _createElementVNode("h1", _hoisted_65, _toDisplayString(_ctx.$t('restrictionMessage.useNdlOnline.cardTitle')), 1),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.useNdlOnline.cardMessage.firstHalf')) + " ", 1),
                _createElementVNode("a", {
                  href: _ctx.$t('link.photoDuplicationsService'),
                  rel: "noopener",
                  class: "level-left is-mobile underline-default",
                  style: {"display":"inline"}
                }, _toDisplayString(_ctx.$t('parts.remoteCopyService')), 9, _hoisted_67),
                _createTextVNode(_toDisplayString(_ctx.$t('restrictionMessage.useNdlOnline.cardMessage.secondHalf', { newLine: '\r\n' })), 1)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: _ctx.$t('link.useNdlOnlinePhotoDuplicationsService'),
                  rel: "noopener",
                  class: "level-left is-mobile"
                }, [
                  _createVNode(_component_AppButton, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('parts.viewInNdlOnlineLink')), 1)
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_68)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ((_ctx.contentPermissionType === 'inlibrary' && (_ctx.location !== 'ndl' && _ctx.location !== 'kss')) || _ctx.contentPermissionType === 'rekion' || _ctx.contentPermissionType === 'ooc' || (_ctx.isKn  && _ctx.contentPermissionType === 'shinsai_ndl_only'))
        ? (_openBlock(), _createElementBlock("section", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppIconPlaces, { type: 'inlibrary' })
                ]),
                _: 1
              }, 8, ["type"]),
              _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t('restrictionMessage.useNdl.underIconMessage', { newLine: '\r\n' })), 1)
            ]),
            _createElementVNode("h1", _hoisted_72, _toDisplayString(_ctx.$t('restrictionMessage.useNdl.cardTitle')), 1),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('restrictionMessage.useNdl.cardMessage')), 1),
              _createElementVNode("p", _hoisted_74, [
                _createElementVNode("a", {
                  href: _ctx.$t('link.TokyoMainLibrary'),
                  rel: "noopener",
                  class: "is-mobile underline-default"
                }, _toDisplayString(_ctx.$t('guidance.thMethod.inlibrary.building1')), 9, _hoisted_75),
                _hoisted_76,
                _createElementVNode("a", {
                  href: _ctx.$t('link.KansaiKan'),
                  rel: "noopener",
                  class: "is-mobile underline-default"
                }, _toDisplayString(_ctx.$t('guidance.thMethod.inlibrary.building2')), 9, _hoisted_77),
                _hoisted_78,
                _createElementVNode("a", {
                  href: _ctx.$t('link.InternationalLibraryOfChildrensLiterature'),
                  rel: "noopener",
                  class: "is-mobile underline-default"
                }, _toDisplayString(_ctx.$t('guidance.thMethod.inlibrary.building3')), 9, _hoisted_79)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.contentPermissionType === 'rekion' && (_ctx.location !== 'rekion' && (_ctx.location !== 'ndl' && _ctx.location !== 'kss')))
        ? (_openBlock(), _createElementBlock("section", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppIconPlaces, { type: _ctx.contentPermissionType }, null, 8, ["type"])
                ]),
                _: 1
              }, 8, ["type"]),
              _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.$t('restrictionMessage.useRekion.underIconMessage', { newLine: '\r\n' })), 1)
            ]),
            _createElementVNode("h1", _hoisted_83, _toDisplayString(_ctx.$t('restrictionMessage.useRekion.cardTitle')), 1),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('restrictionMessage.useRekion.cardMessage')), 1),
              _createElementVNode("p", null, [
                _createVNode(_component_router_link, {
                  to: "/rekion_librarylist",
                  class: "level-left is-mobile"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('parts.listOfRekionLibrary')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.contentPermissionRule === 'out_of_service' && !_ctx.isKn && !_ctx.isRekion)
        ? (_openBlock(), _createElementBlock("section", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createVNode(_component_DssIcon, {
                icon: "book-forbiddan",
                class: "app-icon-places"
              }),
              _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.$t('restrictionMessage.cannotView.underIconMessage')), 1)
            ]),
            _createElementVNode("h1", _hoisted_88, _toDisplayString(_ctx.$t('restrictionMessage.cannotView.cardTitle')), 1),
            _createElementVNode("div", _hoisted_89, [
              (_ctx.hasRestrictionMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString((_ctx.contentRestrictionMessage || _ctx.bundleRestrictionMessage).join('\r\n')), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_91, _toDisplayString(_ctx.$t('restrictionMessage.cannotView.cardMessage.outOfService')), 1))
            ])
          ]))
        : (_ctx.hasRestrictionMessage)
          ? (_openBlock(), _createElementBlock("section", _hoisted_92, [
              _createElementVNode("div", _hoisted_93, [
                _createVNode(_component_DssIcon, {
                  icon: "book-forbiddan",
                  class: "app-icon-places"
                }),
                _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.$t('restrictionMessage.cannotView.underIconMessage')), 1)
              ]),
              _createElementVNode("h1", _hoisted_95, _toDisplayString(_ctx.$t('restrictionMessage.cannotView.cardTitle')), 1),
              _createElementVNode("div", _hoisted_96, [
                (_ctx.hasRestrictionMessage)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString((_ctx.contentRestrictionMessage || _ctx.bundleRestrictionMessage).join('\r\n')), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
      ((_ctx.isFileBundle ? _ctx.bundlePermissionRule : _ctx.contentPermissionRule).startsWith('ndl_only_package') && (_ctx.location === 'ndl' || _ctx.location === 'kss'))
        ? (_openBlock(), _createElementBlock("section", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              _createVNode(_component_DssIcon, {
                icon: "book-forbiddan",
                class: "app-icon-places"
              })
            ]),
            _createElementVNode("h1", _hoisted_100, _toDisplayString(_ctx.$t('restrictionMessage.inlibraryPackageItem.cardTitle', { newLine: '\r\n' })), 1),
            (_ctx.hasRestrictionMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                  _createElementVNode("p", null, _toDisplayString((_ctx.contentRestrictionMessage || _ctx.bundleRestrictionMessage).join('\r\n')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}